// @flow

export function isServerRendering() {
  return typeof window === 'undefined'
}

export function maxMobileWidth() {
  return 991
}

export function windowWidth() {
  if (!isServerRendering()) {
    return window.innerWidth
  }
  return null
}

export function isMobile() {
  const width = windowWidth()
  if (width == null) return null
  return width <= maxMobileWidth()
}



// WEBPACK FOOTER //
// ./src/common/screen.js